import clsx from 'clsx';

import { useItemActions } from '@/hooks/use-item-actions';

import { Modal } from '@flintmint/web-shared/components/modal';

import AiTemplateSvg from './assets/ai-template.svg?react';
import BlankDocumentSvg from './assets/blank-template.svg?react';

import styles from './starting-point-selector.module.scss';

export const StartingPointSelector = (props: StartingPointSelectorProps) => {
  const { open, modal, onClose } = props;

  const { createNew } = useItemActions();

  const documentSelector = (
    <div className={styles.startingPoint} data-testid="starting-point-selector">
      <div className={styles.heading}>
        <h2>Choose your Starting Point</h2>
        <p>Choose a template to start, and customize it later as you wish.</p>
      </div>
      <div className={styles.suggestedDocuments}>
        <div
          className={clsx(styles.suggestedDocument, styles.aiTemplate)}
          onClick={() => {
            createNew({
              type: 'notes',
              domain: 'medical',
            });
            onClose?.();
          }}
        >
          <AiTemplateSvg />
          <div>
            <h3>Medical Note</h3>
            <p>Detailed patient history</p>
          </div>
        </div>
        <div
          className={styles.suggestedDocument}
          onClick={() => {
            createNew({ type: 'notes' });
            onClose?.();
          }}
        >
          <BlankDocumentSvg />
          <div>
            <h3>Blank Document</h3>
            <p>Start with a clean slate</p>
          </div>
        </div>
      </div>
    </div>
  );

  return modal ? (
    <Modal
      open={!!open}
      closeIconSize={24}
      onClose={onClose}
      topDivider={false}
      bottomDivider={false}
      hasFooter={false}
      gap={0}
      data-testid="starting-point-modal"
      modalContentHolderClassName={styles.startingPointModal}
      closeOnEscape
      closeOnClickOutside
    >
      {documentSelector}
    </Modal>
  ) : (
    documentSelector
  );
};

export interface StartingPointSelectorProps {
  open?: boolean;
  modal?: boolean;
  onClose?: () => void;
}
